

export enum KalturaDurationType {
    long = 'long',
	medium = 'medium',
	notAvailable = 'notavailable',
	short = 'short'
}